import { render, staticRenderFns } from "./idcard-uploader.vue?vue&type=template&id=08874c7c&scoped=true&"
import script from "./idcard-uploader.vue?vue&type=script&lang=js&"
export * from "./idcard-uploader.vue?vue&type=script&lang=js&"
import style0 from "./idcard-uploader.vue?vue&type=style&index=0&id=08874c7c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08874c7c",
  null
  
)

export default component.exports